import React from "react"
import { Stack } from "@mui/material"
const styles = {
	"& input": {
		width: "0px",
		height: "0px",
		visibility: "hidden"
	},

	"& .checkbox-label": {
		marginBottom: "25px",
		paddingLeft: "35px",
		display: "inline-block",
		position: "relative",
		cursor: "pointer",

		"@media(max-width: 1024px)": {
			marginBottom: "20px"
		},

		"@media(max-width: 767px)": {
			marginBottom: "15px"
		},

		"&::before": {
			content: "''",
			width: "25px",
			height: "25px",
			position: "absolute",
			top: "50%",
			left: "0%",
			border: "1px solid #465578",
			borderRadius: "5px",
			backgroundSize: "90% auto",
			backgroundRepeat: "no-repeat",
			backgroundPosition: "center",
			transform: "translateY(-50%)",
			transition: "all 0.2s ease"
		}
	},

	"& input:checked + .checkbox-label::before": {
		backgroundImage: `url(/assets/images/onboarding/checkmark.svg)`
	}
}

export default function CheckboxContainer({ sx, children }) {
	return <Stack sx={{ ...styles, ...sx }}>{children}</Stack>
}
